import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const columnSize = 12
export const labelColumnSize = 5
export const valueColumnSize = columnSize - labelColumnSize

export const DividerRow = () => (
  <Grid size={columnSize}>
    <Divider />
  </Grid>
)

export const RowLabel = (props: {
  formattedMessageId: string
  formattedMessageValues?: Record<string, string | number>
  omitColon?: boolean
}) => (
  <Grid
    size={{ xs: columnSize, md: labelColumnSize }}
    display="flex"
    sx={{
      minHeight: '2.5rem',
      paddingLeft: '0.5rem',
      alignItems: 'center',
    }}
  >
    <Typography fontWeight="bold">
      <FormattedMessage
        id={props.formattedMessageId}
        values={props.formattedMessageValues}
      />
      {props.omitColon ? '' : ':'}
    </Typography>
  </Grid>
)

export const RowValue = (props: { children: React.ReactNode }) => (
  <Grid
    size={{ xs: columnSize, md: valueColumnSize }}
    display="flex"
    sx={{
      paddingLeft: '1rem',
      alignItems: 'center',
    }}
  >
    {props.children}
  </Grid>
)
